import {
  Disponibilite,
  Metier,
} from "../schemas-and-types/etablissement/etablissemen.schema";

export const premiereSemaine = [
  // Première semaine
  new Date("2026-06-01"),
  new Date("2026-06-02"),
  new Date("2026-06-03"),
  new Date("2026-06-04"),
  new Date("2026-06-05"),
];

export const deuxiemeSemaine = [
  // Deuxième semaine
  new Date("2026-06-08"),
  new Date("2026-06-09"),
  new Date("2026-06-10"),
  new Date("2026-06-11"),
  new Date("2026-06-12"),
];

export const troisiemeSemaine = [
  // Troisième semaine
  new Date("2026-06-15"),
  new Date("2026-06-16"),
  new Date("2026-06-17"),
  new Date("2026-06-18"),
  new Date("2026-06-19"),
];

export const quatriemeSemaine = [
  // Quatrième semaine
  new Date("2026-06-22"),
  new Date("2026-06-23"),
  new Date("2026-06-24"),
  new Date("2026-06-25"),
  new Date("2026-06-26"),
];

export const cinquiemeSemaine = [
  // Cinquième semaine (jusqu'au 30 juin inclus)
  new Date("2026-06-29"),
  new Date("2026-06-30"),
];

export const disponiblitesPremiereSemaine: Disponibilite[] = [
  ...premiereSemaine.map((jour: Date) => {
    return { date: jour, nombre_professionnel_disponible: 0 };
  }),
];
export const disponiblitesDeuxiemeSemaine: Disponibilite[] = [
  ...deuxiemeSemaine.map((jour: Date) => {
    return { date: jour, nombre_professionnel_disponible: 0 };
  }),
];
export const disponiblitesTroisiemeSemaine: Disponibilite[] = [
  ...troisiemeSemaine.map((jour: Date) => {
    return { date: jour, nombre_professionnel_disponible: 0 };
  }),
];
export const disponiblitesQuatriemeSemaine: Disponibilite[] = [
  ...quatriemeSemaine.map((jour: Date) => {
    return { date: jour, nombre_professionnel_disponible: 0 };
  }),
];
export const disponiblitesCinquiemeSemaine: Disponibilite[] = [
  ...cinquiemeSemaine.map((jour: Date) => {
    return { date: jour, nombre_professionnel_disponible: 0 };
  }),
];

export const defaultMetitersList: Metier[] = [
  {
    title: "Restauration",
    job_title: "Cuisinier(ière)",
    premiere_semaine: disponiblitesPremiereSemaine,
    deuxieme_semaine: disponiblitesDeuxiemeSemaine,
    troisieme_semaine: disponiblitesTroisiemeSemaine,
    quatrieme_semaine: disponiblitesQuatriemeSemaine,
    cinquieme_semaine: disponiblitesCinquiemeSemaine,
    isDisponible: true,
  },
  {
    title: "Maintenance",
    job_title: "Responsable technique ou Technicien(ne)",
    premiere_semaine: disponiblitesPremiereSemaine,
    deuxieme_semaine: disponiblitesDeuxiemeSemaine,
    troisieme_semaine: disponiblitesTroisiemeSemaine,
    quatrieme_semaine: disponiblitesQuatriemeSemaine,
    cinquieme_semaine: disponiblitesCinquiemeSemaine,
    isDisponible: true,
  },

  {
    title: "Accueil et administration",
    job_title: "Agent d'accueil",
    premiere_semaine: disponiblitesPremiereSemaine,
    deuxieme_semaine: disponiblitesDeuxiemeSemaine,
    troisieme_semaine: disponiblitesTroisiemeSemaine,
    quatrieme_semaine: disponiblitesQuatriemeSemaine,
    cinquieme_semaine: disponiblitesCinquiemeSemaine,
    isDisponible: true,
  },
  {
    title: "Hôtellerie - Agent de service hôtelier (ASH)",
    job_title: "Agent de service hôtelier (ASH)",
    premiere_semaine: disponiblitesPremiereSemaine,
    deuxieme_semaine: disponiblitesDeuxiemeSemaine,
    troisieme_semaine: disponiblitesTroisiemeSemaine,
    quatrieme_semaine: disponiblitesQuatriemeSemaine,
    cinquieme_semaine: disponiblitesCinquiemeSemaine,
    isDisponible: true,
  },
  {
    title: "Hôtellerie - Serveur(euse)",
    job_title: "Serveur(euse)",
    premiere_semaine: disponiblitesPremiereSemaine,
    deuxieme_semaine: disponiblitesDeuxiemeSemaine,
    troisieme_semaine: disponiblitesTroisiemeSemaine,
    quatrieme_semaine: disponiblitesQuatriemeSemaine,
    cinquieme_semaine: disponiblitesCinquiemeSemaine,
    isDisponible: true,
  },
  {
    title: "Animation",
    job_title: "Animateur(trice)",
    premiere_semaine: disponiblitesPremiereSemaine,
    deuxieme_semaine: disponiblitesDeuxiemeSemaine,
    troisieme_semaine: disponiblitesTroisiemeSemaine,
    quatrieme_semaine: disponiblitesQuatriemeSemaine,
    cinquieme_semaine: disponiblitesCinquiemeSemaine,
    isDisponible: true,
  },
];
